import React from "react";

const ChipsContainer = ({children}) => {
    return <div className="flex ml-8 mb-4">{children}</div>
}

export default ChipsContainer;